export const STEPS_CONFIG: Tributes.Step[] = [
  'details',
  'media',
  'story',
  'order',
  'preview',
];

export const getStepIndex = (step: Tributes.Step): number => {
  return STEPS_CONFIG.indexOf(step);
};

export const getStepByIndex = (index: number): Tributes.Step | undefined => {
  return STEPS_CONFIG[index];
};
